/**
 * Check if a text will fit in the given horizontal space
 * @param textOrigin - x coord where text begin
 * @param textWidth - width of the text to render
 * @param halfWidth - distance to the bounds from the middle
 */
export const isInHorizontalBounds = (
  textOrigin: number,
  textWidth: number,
  halfWidth: number,
) => textOrigin > -halfWidth && textOrigin + textWidth < halfWidth;
